module.exports = __webpack_public_path__ + "img/is.f4178f5e.svg";